import http from './_http'

const Integrity = (m) => { return http.post(`/wsfinder`, m); }
// const WMDS_Call = (a, b, c) => WMDS({target: a, cmd : b, body: c});

const integrity = { Integrity}


export default integrity
export { Integrity }
